import { LoginInfoState } from '@/config/initialState';
import { store } from '@/config/store';
import { Car, CustomerInfoApiResponse } from '@/types/api/customerApi';

type StoreStateUpdate<StateName extends string> = StateName extends 'loginInfo'
  ? Partial<LoginInfoState>
  : unknown;

export const storeDispatch = async <StateName extends string>(
  actions: string,
  stateName: StateName,
  newState: StoreStateUpdate<StateName>,
) => {
  await store.dispatch(actions, {
    [stateName]: newState,
  });
};

export const dispatchBasicInfo = async (
  customerInfo: CustomerInfoApiResponse['data'],
  findFnc?: (value: Car) => unknown,
) => {
  const {
    customer,
    cars,
    bill_infomations,
    payment_methods,
    prepaids,
    informations,
    campaigns,
  } = customerInfo;
  // この customerInfo がどの法人向けに取得されたかを併せて記録する。
  // customerInfo を更新する経路は多数あるため、共通の完了地点であるここで必ず更新する。
  // 記録が漏れると「取得済みの法人 ≠ 表示中の法人」と判定され続け、
  // ホーム画面のスケルトンが永久に解除されない。
  const customerInfoAffiliateId =
    store.state.selectedTenant?.m_affiliate_id ??
    customer?.m_affiliate_id ??
    null;
  const promises = [
    storeDispatch('setCustomerInfo', 'customerInfo', customer),
    storeDispatch(
      'setCustomerInfoAffiliateId',
      'customerInfoAffiliateId',
      customerInfoAffiliateId,
    ),
    storeDispatch('setCarsInfo', 'carsInfo', cars),
    storeDispatch('setBillsInfo', 'billsInfo', bill_infomations),
    storeDispatch(
      'setPaymentMethodsInfo',
      'paymentMethodsInfo',
      payment_methods,
    ),
    storeDispatch('setAdvancePaymentsInfo', 'advancePaymentsInfo', prepaids),
    storeDispatch('setNotificationsInfo', 'notificationsInfo', informations),
    storeDispatch('setCampaignsInfo', 'campaignsInfo', campaigns),
  ];
  if (cars?.length) {
    const car = (findFnc ? cars.find(findFnc) : cars[0]) || cars[0];
    promises.push(storeDispatch('setCarItemInfo', 'carItemInfo', car));
    if (car?.warranties?.length) {
      promises.push(
        storeDispatch('setWarranties', 'warranties', car.warranties),
      );
      promises.push(
        storeDispatch(
          'setCurrentWarranty',
          'currentWarranty',
          car.warranties?.[0],
        ),
      );
    }
    if (car.next_warranty?.length) {
      promises.push(
        storeDispatch('setNextWarranties', 'nextWarranties', car.next_warranty),
      );
      promises.push(
        storeDispatch(
          'setNextWarranty',
          'nextWarranty',
          car.next_warranty?.[0],
        ),
      );
    }
  }
  await Promise.all(promises);
};
